import {
  Checkbox,
  FormControlLabel,
  Popover,
  Stack,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';

import { ButtonWithIcon } from '@/components/buttons/buttonWithIcon';

import { getDayOfWeekDisplay } from '../frequency';

export const DayOfWeekSelector = ({
  days,
  onChange,
}: {
  days: number[];
  onChange: (days: number[]) => void;
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [popoverOpen, setPopoverOpen] = useState(false);

  return (
    <>
      <ButtonWithIcon
        ref={setAnchorEl}
        onClick={() => setPopoverOpen(true)}
        data-testid='create-backup-policy-day-of-week-select'
        disableFocusRipple
        text={days.map((x) => getDayOfWeekDisplay(x)).join(', ')}
        icon='material-symbols-arrow-drop-down-rounded'
        iconPosition='right'
      />
      <DayOfWeekSelectorPopover
        anchorEl={anchorEl}
        days={days}
        onChange={(value) => {
          setPopoverOpen(false);
          onChange(value);
        }}
        popoverOpen={popoverOpen}
      />
    </>
  );
};

const DayOfWeekSelectorPopover = ({
  days,
  onChange,
  anchorEl,
  popoverOpen,
}: {
  popoverOpen: boolean;
  days: number[];
  onChange: (days: number[]) => void;
  anchorEl: HTMLElement | null;
}) => {
  const [value, setValue] = useState(days);

  useEffect(() => {
    setValue(days);
  }, [days]);

  return (
    <Popover
      disablePortal
      open={popoverOpen}
      anchorEl={anchorEl}
      onClose={() => onChange(value.length ? value.sort() : [0])}
    >
      <Stack className='p-[24px] w-[308px]' gap='24px'>
        <Typography variant='body1'>
          Select at least one day for backups.
        </Typography>
        {Array.from({ length: 7 }, (_, i) => i).map((day) => (
          <FormControlLabel
            key={day}
            control={
              <Checkbox
                checked={value.includes(day)}
                onChange={(event, value) =>
                  setValue((state) =>
                    value ? [...state, day] : state.filter((x) => x !== day)
                  )
                }
              />
            }
            label={
              <Typography fontSize={'13px'} className='ml-[12px]'>
                {getDayOfWeekDisplay(day)}
              </Typography>
            }
          />
        ))}
      </Stack>
    </Popover>
  );
};
